import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { userService } from 'src/services/user.service'

import { QUERY_KEYS, STORAGE_KEYS } from 'src/constants'

const useMe = (userId?: string) => {
  const { i18n } = useTranslation()

  return useQuery(
    [QUERY_KEYS.USER, userId],
    () => {
      if (
        !localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) ||
        !localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)
      ) {
        return null
      }

      return userService.getMe(userId)
    },
    {
      onSuccess: async (data) => {
        if (!data) return

        if (i18n.language !== data.language.code) {
          await i18n.changeLanguage(data.language.code)
        }
        moment.locale(i18n.language)
      },
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: true,
      retryDelay: 5000,
    },
  )
}

export { useMe }
